module.exports = __webpack_public_path__ + "img/2.fe0905d0.png";